import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ProductDetailsComponent} from "./product-details/product-details.component";
import {ImageContainerComponent} from "./product-details/image-container/image-container.component";
import {CompareComponent} from "./product-details/compare/compare.component";
import {SpecificationsComponent} from "./product-details/specifications/specifications.component";
import {SidebarComponent} from "../../layout/sidebar/sidebar.component";
import {ProductFilterComponent} from "./product-filter/product-filter.component";
import {MenuModule} from "primeng/menu";
import {SidebarModule} from "primeng/sidebar";
import {CarouselModule} from "primeng/carousel";
import {GalleriaModule} from "primeng/galleria";
import {ListingComponent} from "./listing/listing.component";
import {ChipModule} from "primeng/chip";
import {TagModule} from "primeng/tag";
import {ChipsModule} from "primeng/chips";
import {ComponentsModule} from "../components/components.module";
import {ButtonModule} from "primeng/button";
import {NoDataComponent} from "../components/no-data/no-data.component";
import {CardModule} from "primeng/card";
import {OverlayPanelModule} from "primeng/overlaypanel";


@NgModule({
  declarations: [
    ProductDetailsComponent,
    ImageContainerComponent,
    CompareComponent,
    SpecificationsComponent,
    SidebarComponent,
    ProductFilterComponent,
    ListingComponent,
    NoDataComponent
  ],
    imports: [
      CommonModule,
      MenuModule,
      SidebarModule,
      CarouselModule,
      GalleriaModule,
      ChipModule,
      ChipsModule,
      TagModule,
      ComponentsModule,
      ButtonModule,
      CardModule,
      OverlayPanelModule
    ]
})
export class ProductsModule { }
